import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useGetSubtaskTemplates } from '@/shared/hooks/task/useGetSubtaskTemplates';
import { useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { listItemMsg } from '../../FormattedListValue';
import AutoComplete from '../select/AutoComplete';
export var SubtaskTemplateSelect = function (_a) {
    var initialValue = _a.initialValue, placeholder = _a.placeholder, taskTemplateId = _a.taskTemplateId, isDisabled = _a.isDisabled, onChange = _a.onChange;
    var formatMessage = useIntl().formatMessage;
    var _b = useGetSubtaskTemplates(taskTemplateId), data = _b.data, refetch = _b.refetch;
    useEffect(function () {
        refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [taskTemplateId]);
    var subtaskTemplates = useMemo(function () {
        return data === null || data === void 0 ? void 0 : data.map(function (item) { return ({
            key: item.id,
            label: formatMessage(listItemMsg('taskTemplate', item.id, item.name)),
        }); });
    }, [data, formatMessage]);
    var initialSelectedItem = useMemo(function () { var _a; return (_a = (initialValue && (subtaskTemplates === null || subtaskTemplates === void 0 ? void 0 : subtaskTemplates.find(function (item) { return (item === null || item === void 0 ? void 0 : item.key) === initialValue; })))) !== null && _a !== void 0 ? _a : undefined; }, [initialValue, subtaskTemplates]);
    return (_jsx(AutoComplete, { items: subtaskTemplates, initialSelectedItem: initialSelectedItem, placeholder: placeholder, mode: "edit", onChange: function (item) { return onChange(item === null || item === void 0 ? void 0 : item.key); }, disabled: isDisabled }));
};
export var FilterSubtaskTemplateSelect = function (_a) {
    var _b;
    var item = _a.item, taskTemplatesItem = _a.taskTemplatesItem, setFilter = _a.setFilter, activeFilters = _a.activeFilters, label = _a.label, isAlwaysVisible = _a.isAlwaysVisible, enabled = _a.enabled;
    var taskTemplates = (_b = activeFilters[taskTemplatesItem]) !== null && _b !== void 0 ? _b : [];
    var taskTemplateId = taskTemplates.length === 1 ? taskTemplates[0] : null;
    return {
        enabled: enabled,
        filterItem: item,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(SubtaskTemplateSelect, { onChange: function (value) {
                var _a;
                return setFilter((_a = {}, _a[item] = value !== null && value !== void 0 ? value : undefined, _a));
            }, initialValue: activeFilters[item], taskTemplateId: taskTemplateId, placeholder: label, isDisabled: !taskTemplateId })),
    };
};
